export const getFirstAndLastElement = (arr) => {
    const sorted = arr.slice().sort((a, b) => a.value - b.value);
    return {
        first: sorted[0],
        last: sorted[sorted.length - 1],
    };
}

export const getMin = (arr) => {
    return Math.min(...arr.map(item => item.value)); 
}

export const getMax = (arr) => {
    return Math.max(...arr.map(item => item.value)); 
}

export const getStep = (arr) => {
    // Sort first
    const sorted = arr.slice().sort((a, b) => a.value - b.value);
    // Determine minimum difference between adjacent values
    let minStep = Infinity;
    for (let i = 1; i < sorted.length; i++) {
        const diff = sorted[i].value - sorted[i - 1].value;
        if (diff < minStep) {
            minStep = diff;
        }
    }
    return minStep;
}